import tw from './zh-tw.js'
import cn from './zh-cn.js'

const messages = {
    'zh-tw': tw,
    'zh-cn': cn,
}

export default messages
